import { Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild, ViewChildren } from '@angular/core';
import {
    ModalController,
    ActionSheetController,
    AlertController,
    Platform,
} from '@ionic/angular';
import { AppointmentWizardSettingsService } from '../../../../shared/state/appointment-wizard-settings/appointment-wizard-settings.service';
import { AppointmentWizardSettingsQuery } from '../../../../shared/state/appointment-wizard-settings/appointment-wizard-settings.query';
import { BehaviorSubject, combineLatest, Observable, of, Subject } from 'rxjs';
import { AppointmentWizardSettingsState } from '../../../../shared/state/appointment-wizard-settings/appointment-wizard-settings.store';
import { LibraryService } from '../../../../core/services/library/library.service';
import { FamilyWizardModel } from '../../../../shared/models/family-wizard.model';
import { ServiceWizardQuery } from '../../../../shared/state/service-wizard/service-wizard.query';
import {
    ServiceWizard,
    ServiceWizardCheckedEvent,
} from '../../../../shared/state/service-wizard/service-wizard.model';
import { ServiceWizardService } from '../../../../shared/state/service-wizard/service-wizard.service';
import { filter, map, take, takeUntil } from 'rxjs/operators';
import { IdsStepsAppointmentWizardModel } from '../../../../shared/models/idsStepsAppointmentWizard.model';
import { WizardStep } from '../../../../shared/state/wizard-step/wizard-step.model';
import { WizardStepService } from '../../../../shared/state/wizard-step/wizard-step.service';
import { WizardStepQuery } from '../../../../shared/state/wizard-step/wizard-step-query';
import { CalendarComponent } from '../../components/calendar/calendar.component';
import { NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { AppointmentWizardTimeService } from '../../../../shared/state/appointment-wizard-time/appointment-wizard-time.service';
import { AppointmentWizardTime } from '../../../../shared/state/appointment-wizard-time/appointment-wizard-time.model';
import { AppointmentWizardTimeQuery } from '../../../../shared/state/appointment-wizard-time/appointment-wizard-time.query';
import { AppointmentWizardDateService } from '../../../../shared/state/appointment-wizard-date/appointment-wizard-date.service';
import { AppointmentWizardDateQuery } from '../../../../shared/state/appointment-wizard-date/appointment-wizard-date.query.';
import { AppointmentWizardDate } from '../../../../shared/state/appointment-wizard-date/appointment-wizard-date.model';
import { PaymentWizardSettingsService } from '../../../../shared/state/payment-wizard-settings/payment-wizard-settings.service';
import { PaymentWizardSettingsQuery } from '../../../../shared/state/payment-wizard-settings/payment-wizard-settings.query';
import { Router } from '@angular/router';
import { UserQuery } from '../../../../shared/state/user/user.query';
import { ClinicDetailQuery } from '../../../../shared/state/clinic-detail/clinic-detail.query';
import { UserRegisterModel } from '../../../../shared/models/userRegister.model';
import { RegisterFormComponent } from '../../../../shared/components/register-form/register-form.component';
import { UserService } from '../../../../shared/state/user/user.service';
import { ToastService } from '../../../../core/services/toast/toast.service';
import { SettingsQuery } from '../../../../shared/state/settings/settings.query';
import { AppointmentService } from '../../../../shared/state/appointment/appointment.service';
import { PaymethodWizard } from '../../../../shared/state/paymethod-wizard/paymethod-wizard.model';
import { PaymethodWizardQuery } from '../../../../shared/state/paymethod-wizard/paymethod-wizard.query';
import { PaymethodWizardService } from '../../../../shared/state/paymethod-wizard/paymethod-wizard.service';
import { TreatmentService } from '../../../../shared/state/treatment/treatment.service';
import { ServicesGroupService } from 'src/app/shared/state/services-group/services-group.service';
import { ServicesGroupQuery } from 'src/app/shared/state/services-group/services-group.query';
import {
    ProfessionalServiceGroupSelected,
    ServicesGroup,
} from 'src/app/shared/state/services-group/services-group.model';
import { CompanyQuery } from 'src/app/shared/state/company/company.query';
import { ServiceSearchbarComponent } from '../../../../shared/components/service-searchbar/service-searchbar.component';
import { LoadingService } from '../../../../shared/state/loading/loading.service';
import { CalendarDeviceService } from '../../../../core/services/calendar-device/calendar-device.service';
import { KeyboardQuery } from '../../../../shared/state/keyboard/keyboard.query';
import { RouterService } from '../../../../core/services/router/router.service';
import { FamilyFolderModel } from '../../../../shared/models/family-folder.model';
import { GenericHeaderComponent } from '../../../../shared/components/generic-header/generic-header.component';
import {
    OtpModalComponent,
    OTPModalDismissActions,
} from '../../../../shared/components/otp-modal/otp-modal.component';
import { SocialLoginQuery } from '../../../../shared/state/social-login/social-login.query';
import { SocialLoginService } from '../../../../shared/state/social-login/social-login.service';
import { ClientDataSocialLogin } from '../../../../shared/state/social-login/social-login.store';
import { InputSearchComponent } from 'src/app/shared/components/input-search/input-search.component';
import {
    templateProfessionalsActionButtonDisabled,
    templateProfessionalsStepCheckShowActionButton,
    templateProfessionalsNextStep,
    templateGoBackSlideProfessional,
    templateProfessionalUndoNextStep,
    templateDatetimeStepCheckShowActionButton,
    templateDatetimeActionButtonDisabled,
    templatePaymethodsStepCheckShowActionButton,
    templatePaymethodsActionButtonDisabled,
    templatePaymethodUndoNextStep,
    templateResultStepCheckShowActionButton,
    stepsLabels
} from './appointment-wizard.functions';
import { HeaderPictureQuery } from 'src/app/shared/state/header-picture/header-picture.query';
import { SwiperOptions } from 'swiper';
import { PackWizardQuery } from 'src/app/shared/state/pack-wizard/pack-wizard.query';
import { PacksWizardService } from 'src/app/shared/state/pack-wizard/pack-wizard.service';
import { PackWizard } from 'src/app/shared/state/pack-wizard/pack-wizard.model';

@Component({
    selector: 'app-appointment-wizard',
    templateUrl: './appointment-wizard.component.html',
    styleUrls: ['./appointment-wizard.component.scss'],
})

/**
 * TODO: Ver si puedo mejorar el doble filtrado por familias y por buscador de texto
 * TODO: Animaciones en los checkboxes
 */
export class AppointmentWizardComponent implements OnInit, OnDestroy {
    @ViewChild(RegisterFormComponent)
    registerFormComponent: RegisterFormComponent;
    @ViewChild(ServiceSearchbarComponent)
    serviceSearchBar: ServiceSearchbarComponent;
    @ViewChild(GenericHeaderComponent) genericHeader: GenericHeaderComponent;
    @ViewChild(CalendarComponent) calendar: CalendarComponent;
    /** Flowwwer template */
    @ViewChild(InputSearchComponent) inputSearch: InputSearchComponent;
    @ViewChild('swiper') swiperContainer: ElementRef;

    appointmentWizardSettings$: Observable<AppointmentWizardSettingsState>;
    familiesWizard$: Observable<FamilyWizardModel[]>;
    familiesFilterWizard$: Observable<FamilyWizardModel[]>;
    appDelegate$: Observable<boolean>;
    servicesWizard$: Observable<
        ServiceWizard[]
    >; /** Servicios filtrados por familias y buscador */
    servicesWizardFamily$: Observable<
        ServiceWizard[]
    >; /** Servicios filtrados por familias */
    servicesChecked$: Observable<
        ServiceWizard[]
    >; /** Servicios seleccionados por el usuario */

    stepActive$: Observable<WizardStep>;
    slideActiveIndex: number;
    /** Opciones iniciales del asistente */
    slideOpts: SwiperOptions = {};
    disabledButtonAction$: Observable<boolean>;
    labelButtonAction$: Observable<string>;
    showActionButton$: Observable<boolean>;
    times$: Observable<AppointmentWizardTime[]>;
    isDisabledDateCalendar;
    dateActive$: Observable<AppointmentWizardDate>;
    timeActive$: Observable<AppointmentWizardTime>;
    timeLoading$: Observable<boolean>;
    clinicDetailRgpdDisable$: Observable<boolean>;
    paymethodsWizard$: Observable<PaymethodWizard[]>;
    urlPaymentSafe$: Observable<any>;
    listenerEventsPayment;
    isLoadingContent;
    servicesGroup$: Observable<ServicesGroup[]>;
    keyboardIsShowing: Observable<boolean>;
    noMoreServices$: Observable<boolean>;
    familyFolderTree: FamilyFolderModel;
    familyFolderSlide: FamilyFolderModel[] = [];
    familyFolderSlideFiltered: FamilyFolderModel[] = [];
    idsStepsAppointmentWizardModel = IdsStepsAppointmentWizardModel;
    clientDataSocialLogin: ClientDataSocialLogin | {};
    socialLoginResponse$;
    clinicName$: Observable<string>;
    headerCurrentStep = 0;
    packsWizard$: Observable<PackWizard[]>;

    /** Flowwwer template */
    IdsStepsAppointmentWizardModelRESULT =
        IdsStepsAppointmentWizardModel.RESULT;
    slideActiveProfessionalIndex: number;
    slideActiveProfessionalIndexSubject: BehaviorSubject<
        number
    > = new BehaviorSubject(null);
    servicesGroups: ServicesGroup[];
    logoHeader: string = null;
    familyFolderUserAction$ = new Subject<boolean>();

    /** 1º Introducimos todos los pasos del asistente en el Store */
    appointmentWizardSteps: WizardStep[] = [
        {
            id: IdsStepsAppointmentWizardModel.FAMILIES,
            titleLabel: stepsLabels.FAMILIES,
            actionLabel: 'app_ask_sched_step_1_button',
            showActionButton: true,
        },
        {
            id: IdsStepsAppointmentWizardModel.PROFESSIONALS,
            titleLabel: stepsLabels.PROFESSIONALS,
            actionLabel: 'app_ask_sched_step_1_button',
            showActionButton: false,
        },
        {
            id: IdsStepsAppointmentWizardModel.DATETIME,
            titleLabel: stepsLabels.DATETIME,
            actionLabel: 'app_ask_sched_step_1_button',
            showActionButton: false,
        },
        {
            id: IdsStepsAppointmentWizardModel.SOCIAL_LOGIN,
            titleLabel: stepsLabels.SOCIAL_LOGIN,
            actionLabel: '',
            showActionButton: false,
        },
        {
            id: IdsStepsAppointmentWizardModel.REGISTER,
            titleLabel: stepsLabels.REGISTER,
            actionLabel: 'app_ask_sched_step_5_button_confirm',
            showActionButton: true,
        },
        {
            id: IdsStepsAppointmentWizardModel.PAYMETHODS,
            titleLabel: stepsLabels.PAYMETHODS,
            actionLabel: 'app_ask_sched_step_1_button',
            showActionButton: false,
        },
        {
            id: IdsStepsAppointmentWizardModel.CONFIRM,
            titleLabel: stepsLabels.CONFIRM,
            actionLabel: 'app_ask_sched_step_5_button_confirm',
            showActionButton: true,
        },
        {
            id: IdsStepsAppointmentWizardModel.PAYMENT,
            titleLabel: stepsLabels.PAYMENT,
            actionLabel: '',
            showActionButton: false,
        },
        {
            id: IdsStepsAppointmentWizardModel.RESULT,
            titleLabel: stepsLabels.RESULT,
            actionLabel: 'lbl_appointments_see',
            showActionButton: false,
        },
    ];

    get servicesDescription$() {
        return this.servicesChecked$.pipe(
            map((services) => services.map(({ description }) => description))
        );
    }

    constructor(
        private modalController: ModalController,
        private appointmentWizardSettingsService: AppointmentWizardSettingsService,
        private appointmentWizardSettingsQuery: AppointmentWizardSettingsQuery,
        private libraryService: LibraryService,
        private serviceWizardQuery: ServiceWizardQuery,
        private serviceWizardService: ServiceWizardService,
        private wizardStepService: WizardStepService,
        private wizardStepQuery: WizardStepQuery,
        private appointmentWizardTimeService: AppointmentWizardTimeService,
        private appointmentWizardTimeQuery: AppointmentWizardTimeQuery,
        private appointmentWizardDateService: AppointmentWizardDateService,
        private appointmentWizardDateQuery: AppointmentWizardDateQuery,
        private paymentWizardSettingsService: PaymentWizardSettingsService,
        private paymentWizardSettingsQuery: PaymentWizardSettingsQuery,
        private actionSheetController: ActionSheetController,
        private router: Router,
        private userQuery: UserQuery,
        private clinicDetailQuery: ClinicDetailQuery,
        private userService: UserService,
        private toastService: ToastService,
        private settingsQuery: SettingsQuery,
        private appointmentService: AppointmentService,
        private paymethodWizardQuery: PaymethodWizardQuery,
        private paymethodWizardService: PaymethodWizardService,
        private treatmentService: TreatmentService,
        private alertCtrl: AlertController,
        private servicesGroupService: ServicesGroupService,
        private servicesGroupQuery: ServicesGroupQuery,
        private platform: Platform,
        private companyQuery: CompanyQuery,
        private ngZone: NgZone,
        private loadingService: LoadingService,
        private calendarDeviceService: CalendarDeviceService,
        private keyboardQuery: KeyboardQuery,
        private routerService: RouterService,
        private socialLoginQuery: SocialLoginQuery,
        private socialLoginService: SocialLoginService,
        private headerPicturesQuery: HeaderPictureQuery,
        private packWizardQuery: PackWizardQuery,
        private packWizardService: PacksWizardService
    ) {}

    ngOnInit(): void {
        this.clinicName$ = this.clinicDetailQuery.select('commercialName');
        this.appDelegate$ = this.clinicDetailQuery.select('appDelegate');
        this.keyboardIsShowing = this.keyboardQuery.select('isShowing');
        this.isLoadingContent = true;
    }

    async ngAfterViewInit() {
        try {
            await this.initWizardConfig();
        } catch (error) {
            this.isLoadingContent = false;
            this.loadingService.updateShowSpinner(false);
        }
        this.isLoadingContent = false;

        this.stepActive$.subscribe((step) => {
            if (step) {
                if (step.id < IdsStepsAppointmentWizardModel.DATETIME) {
                    this.headerCurrentStep = 0;
                } else if (step.id < IdsStepsAppointmentWizardModel.CONFIRM) {
                    this.headerCurrentStep = 1;
                } else {
                    this.headerCurrentStep = 2;
                }
            }
        });

        /** Flowwwer template */
        this.headerPicturesQuery
            .select('homeCompany')
            .subscribe((homeCompany) => {
                this.logoHeader = homeCompany;
            });
    }

    goBack(): void {
        const { stepStack } = this.appointmentWizardSettingsQuery.getValue();
        const currentStep: WizardStep = this.wizardStepQuery.getActive();

        if (currentStep?.id === IdsStepsAppointmentWizardModel.RESULT) {
            this.dismissModal();
            return;
        }

        if (
            currentStep?.id === IdsStepsAppointmentWizardModel.FAMILIES &&
            this.slideActiveIndex > 0
        ) {
            this.popFamilyFolder();
            return;
        }

        /** Flowwwer template */
        if (currentStep?.id === IdsStepsAppointmentWizardModel.PROFESSIONALS) {
            const checkGoToPrevStep = this.goBackSlideProfessional();
            if (!checkGoToPrevStep) {
                return;
            }
        }

        if (stepStack?.length > 0) {
            this.goToPrevStep();
            return;
        }

        this.dismissModal();
    }

    ionViewDidEnter() {
        this.swiperContainer?.nativeElement.swiper.update();
    }

    dismissModal() {
        this.modalController.dismiss({
            dismissed: true,
        });

        /** Comprobamos si el paso que cerramos es uno cualquiera o el último para ir al apartado de mis citas */
        const currentStep: WizardStep = this.wizardStepQuery.getActive();
        if (
            currentStep &&
            currentStep.id === IdsStepsAppointmentWizardModel.RESULT
        ) {
            this.router.navigate([
                this.settingsQuery.systemKeyURL +
                    '/' +
                    this.clinicDetailQuery.id +
                    '/appointment',
            ]);
        }
    }

    /*-----------------------------*/
    /** FUNCIONES GENÉRICAS WIZARD */
    /*-----------------------------*/

    /** Función que inicializa el primera paso. No hay que hacer el avance con slide porque aun no está el objeto creado y se inicia solo */
    goToInitStep(initStep: WizardStep) {
        /** 1º Inicializamos el paso siguiente */
        this.initNextStep(initStep);

        /** 2º Avanzamos al paso siguiente */
        this.goToStep(initStep);
    }

    /** Función que retrocede de un paso a otro */
    goToPrevStep() {
        /** 1º Hace los cambios necesarios al destruir un paso y volver atrás */
        const currentStep: WizardStep = this.wizardStepQuery.getActive();
        this.destroyCurrentStep(currentStep);

        /** 2º Retrocede al paso anterior, buscando en la pila de pasos */
        const prevStep: WizardStep = this.wizardStepQuery.getEntity(
            this.appointmentWizardSettingsQuery.stepStack[
                this.appointmentWizardSettingsQuery.stepStack.length - 1
            ]
        );
        this.undoNextStep(prevStep);
        this.goToStep(prevStep);

        /** 3º Saca el paso que vamos a dejar atrás de la pila */
        this.appointmentWizardSettingsService.popStepStack();
    }

    /** Función que inicializa uno de los pasos */
    destroyCurrentStep(currentStep: WizardStep) {
        switch (currentStep.id) {
            case IdsStepsAppointmentWizardModel.FAMILIES: {
                this.destroyFamilyStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.PROFESSIONALS: {
                this.destroyProfessionalsStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.DATETIME: {
                this.destroyDateTimeStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.SOCIAL_LOGIN: {
                this.destroySocialLoginStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.REGISTER: {
                this.destroyRegisterStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.CONFIRM: {
                this.destroyConfirmStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.PAYMETHODS: {
                this.destroyPaymethodStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.PAYMENT: {
                this.destroyPaymentStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.RESULT: {
                this.destroyResultStep();
                break;
            }
        }
    }

    /** Función que avanza de un paso a otro */
    goToNextStep(nextStepId: number, addCurrentStepToStak = true) {
        const currentStep: WizardStep = this.wizardStepQuery.getActive();
        /** 1º En la pila de pasos, añade el paso que vamos a dejar atrás */
        if (addCurrentStepToStak) {
            this.appointmentWizardSettingsService.pushStepStack(currentStep.id);
        }

        /** 2º Inicializamos el paso siguiente */
        const nextStep: WizardStep = this.wizardStepQuery.getEntity(nextStepId);
        this.initNextStep(nextStep);

        /** 3º Avanzamos al paso siguiente */
        this.goToStep(nextStep);
    }

    /** Función que inicializa uno de los pasos */
    initNextStep(nextStep: WizardStep) {
        switch (nextStep.id) {
            case IdsStepsAppointmentWizardModel.FAMILIES: {
                this.initFamilyStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.PROFESSIONALS: {
                this.initProfessionalStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.DATETIME: {
                this.initDatetimeStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.SOCIAL_LOGIN: {
                this.initSocialLoginStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.REGISTER: {
                this.initRegisterStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.CONFIRM: {
                this.initConfirmStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.PAYMETHODS: {
                this.initPaymethodStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.PAYMENT: {
                this.initPaymentStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.RESULT: {
                this.initResultStep();
                break;
            }
        }
    }

    /** Función que avanza al paso siguiente */
    goToStep(step: WizardStep) {
        /** 1º Se mueve al paso siguiente con la librería de slides */
        this.swiperContainer?.nativeElement.swiper.slideTo(step.id);

        /** 2º Actualiza el paso activo actual */
        this.wizardStepService.setActive(step.id.toString());

        /** 3º Actualiza el disabled del botón de acción según el paso y su label */
        this.checkShowActionButton();
        this.getLabelActionButton();
        this.checkDisabledButtonAction();
    }

    /** Cuando se pulsa el botón de continuar (si lo hay), se llama a la función de next step  de los pasos */
    actionNextStep() {
        const currentStep: WizardStep = this.wizardStepQuery.getActive();
        switch (currentStep.id) {
            case IdsStepsAppointmentWizardModel.FAMILIES: {
                this.familyNextStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.PROFESSIONALS: {
                this.professionalsNextStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.DATETIME: {
                this.dateTimeNextStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.SOCIAL_LOGIN: {
                this.socialLoginNextStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.REGISTER: {
                this.registerNextStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.CONFIRM: {
                this.confirmNextStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.PAYMETHODS: {
                this.paymethodNextStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.PAYMENT: {
                this.paymentNextStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.RESULT: {
                this.resultNextStep();
                break;
            }
        }
    }

    undoNextStep(step: WizardStep) {
        switch (step.id) {
            case IdsStepsAppointmentWizardModel.FAMILIES: {
                this.familyUndoNextStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.PROFESSIONALS: {
                this.professionalUndoNextStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.DATETIME: {
                this.datetimeUndoNextStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.SOCIAL_LOGIN: {
                this.socialLoginUndoNextStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.REGISTER: {
                this.registerUndoNextStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.CONFIRM: {
                break;
            }
            case IdsStepsAppointmentWizardModel.PAYMETHODS: {
                this.paymethodUndoNextStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.PAYMENT: {
                this.paymentUndoNextStep();
                break;
            }
            case IdsStepsAppointmentWizardModel.RESULT: {
                this.resultUndoNextStep();
                break;
            }
        }
    }

    /*--------------------------------------*/
    /** CONFIGURACIÓN DISABLED BOTÓN ACCIÓN */
    /*--------------------------------------*/

    checkDisabledButtonAction() {
        const currentStep: WizardStep = this.wizardStepQuery.getActive();
        switch (currentStep.id) {
            case IdsStepsAppointmentWizardModel.FAMILIES:
                this.disabledButtonAction$ = this.familyActionButtonDisabled();
                break;
            case IdsStepsAppointmentWizardModel.PROFESSIONALS:
                this.disabledButtonAction$ = this.professionalsActionButtonDisabled();
                break;
            case IdsStepsAppointmentWizardModel.DATETIME:
                this.disabledButtonAction$ = this.datetimeActionButtonDisabled();
                break;
            case IdsStepsAppointmentWizardModel.CONFIRM:
                this.disabledButtonAction$ = this.confirmActionButtonDisabled();
                break;
            case IdsStepsAppointmentWizardModel.REGISTER:
                this.disabledButtonAction$ = of(false);
                break;
            case IdsStepsAppointmentWizardModel.PAYMETHODS:
                this.disabledButtonAction$ = this.paymethodsActionButtonDisabled();
                break;
            case IdsStepsAppointmentWizardModel.RESULT:
                this.disabledButtonAction$ = of(false);
                break;
            default:
                this.disabledButtonAction$ = of(true);
                break;
        }
    }

    /*--------------------------------------*/
    /** LABEL PARA EL BOTÓN DE BOTÓN ACCIÓN */
    /*--------------------------------------*/

    getLabelActionButton() {
        const currentStep: WizardStep = this.wizardStepQuery.getActive();
        switch (currentStep.id) {
            case IdsStepsAppointmentWizardModel.CONFIRM: {
                this.labelButtonAction$ = this.getActionLabelConfirmStep();
                break;
            }
            default:
                this.labelButtonAction$ = of(currentStep.actionLabel);
                break;
        }
    }

    /*--------------------------------------*/
    /** MOSTRAR O NO EL BOTÓN DE ACCIÓN */
    /*--------------------------------------*/

    checkShowActionButton() {
        const currentStep: WizardStep = this.wizardStepQuery.getActive();
        switch (currentStep.id) {
            case IdsStepsAppointmentWizardModel.PROFESSIONALS:
                this.showActionButton$ = this.professionalsStepCheckShowActionButton();
                break;
            case IdsStepsAppointmentWizardModel.DATETIME:
                this.showActionButton$ = this.datetimeStepCheckShowActionButton();
                break;
            case IdsStepsAppointmentWizardModel.PAYMETHODS:
                this.showActionButton$ = this.paymethodsStepCheckShowActionButton();
                break;
            case IdsStepsAppointmentWizardModel.RESULT:
                this.showActionButton$ = this.resultStepCheckShowActionButton();
                break;
            default:
                this.showActionButton$ = of(currentStep.showActionButton);
                break;
        }
    }

    /*------------------------*/
    /** CONFIGURACIÓN PASO 0  */
    /*------------------------*/

    /** Configuración inicial del asistente. Definimos cual es el primer paso y su primer título */
    async initWizardConfig() {
        this.slideOpts = {
            speed: 200,
            allowTouchMove: false
        };
        Object.assign(this.swiperContainer?.nativeElement, this.slideOpts);

        this.wizardStepService.setWizardSteps(this.appointmentWizardSteps);

        this.stepActive$ = this.wizardStepQuery.selectActive();

        /** Cargamos la configuración inicial del asistente de pedir cita */
        this.appointmentWizardSettings$ = this.appointmentWizardSettingsQuery.select();

        /** Obtenemos las familias sin duplicar (desarrollo de centros delegados) */
        this.familiesWizard$ = this.appointmentWizardSettingsQuery.selectFamiliesDistinct;

        /** Obtenemos los servicios */
        this.servicesWizard$ = this.serviceWizardQuery.selectAll();

        //** Obtenemos los packs */
        this.packsWizard$ = this.packWizardQuery.selectAll();

        /** Juntamos el paso 0 (Familias) y 1 (Servicios) (desarrollo de folder families) */
        this.appointmentWizardSettingsQuery
            .selectFamilyFolderTree(
                this.familiesWizard$,
                this.servicesWizard$,
                of([]),
                this.packsWizard$
            )
            .pipe(
                takeUntil(this.familyFolderUserAction$)
            )
            .subscribe((familyFolderRoot) => {
                this.familyFolderTree = familyFolderRoot;

                this.familyFolderSlide[0] = { ...this.familyFolderTree };
                this.familyFolderSlideFiltered[0] = {
                    ...this.familyFolderTree,
                };

                if (this.serviceSearchBar) {
                    this.onChangeFamilySearchbar(
                        this.serviceSearchBar.searchBar.value
                    );
                }
            });

        this.loadingService.updateShowSpinner(true);
        await this.appointmentWizardSettingsService.getAppointmentWizardSettings();
        this.loadingService.updateShowSpinner(false);

        let stepInitial: WizardStep;

        stepInitial = this.wizardStepQuery.getEntity(
            IdsStepsAppointmentWizardModel.FAMILIES
        );

        this.slideOpts = {
            initialSlide: stepInitial.id,
            speed: 200,
            allowTouchMove: false,
        };
        Object.assign(this.swiperContainer?.nativeElement, this.slideOpts);
        this.swiperContainer?.nativeElement.initialize();

        this.goToInitStep(stepInitial);
    }

    /*------------------------------------------*/
    /** INSTRUCCIONES PARA CREAR UN PASO NUEVO
     * Para crear un paso nuevo, los requisitos son los siguientes:
     * Cada paso tiene que ser añadido al objeto de configuración de pasos, indicando su número de paso y su título de paso.
     * Cada paso tiene que tener una función inicializadora del paso,otra que lo destruya y otra que deshará la acción de ir al siguiente paso.
     * En estas funciones pondremos las acciones que necesitamos hacer cuando se entra a ese paso (inicialización)
     * en concreto y lo que hay que hacer cuando se vuelve de ese paso en concreto (limpieza)
    /*------------------------------------------*/

    /*--------------------*/
    /** PASO 0: FAMILIAS  */
    /*--------------------*/

    initFamilyStep() {
        this.slideActiveIndex = 0;

        /** Se inicia el observable de los servicios selecionados por el usuario */
        this.servicesChecked$ = this.serviceWizardQuery.selectAll({
            filterBy: ({ checked }) => checked === true,
        });
        this.noMoreServices$ = this.servicesChecked$.pipe(
            map((services) => {
                return (
                    services.length >=
                    parseInt(this.companyQuery.maxServices, 10)
                );
            })
        );
    }

    /** Paso de familias del asistente. Hemos pulsado una familia */
    onFamilyClicked(family: FamilyFolderModel) {
        this.familyFolderUserAction$.next(true);
        this.resetFamilySearchbar();
        this.slideActiveIndex++;
        this.familyFolderSlide[this.slideActiveIndex] = { ...family };
        this.familyFolderSlideFiltered[this.slideActiveIndex] = family;
        this.swiperContainer?.nativeElement.swiper.slideTo(this.slideActiveIndex);
    }

    popFamilyFolder() {
        this.resetFamilySearchbar();
        this.slideActiveIndex--;
        this.swiperContainer?.nativeElement.swiper.slideTo(this.slideActiveIndex);
    }

    resetFamilySearchbar() {
        if (this.serviceSearchBar) {
            this.serviceSearchBar.clearInput();
        }

        if (this.genericHeader) {
            this.genericHeader.clearInput();
        }

        /** Flowwwer template */
        if (this.inputSearch) {
            this.inputSearch.clearInput();
        }

        this.onChangeFamilySearchbar('');
    }

    async familyNextStep() {
        /** Llamamos a la API para ver cual es el siguiente paso */

        /** Llamamos a la API para cargar los grupos de servicios.
         * Posibles respuestas:
         * 0 grupos, no es posible esa cita de ninguna forma
         * 1 grupo con listado de prof -> Selección de profesionales normal,
         * 1 grupo sin listado de prof -> Saltamos al paso de dia hora,
         * varios grupos con listado de prof -> Nueva selección de profesionales,
         * varios grupos sin listado -> Saltamos al paso de dia hora (comprobar esta casuistica con la de javi)
         */

        this.servicesGroup$ = this.servicesGroupQuery.selectAll();

        /** Flowwwer template */
        this.servicesGroup$.subscribe((servicesGroup: ServicesGroup[]) => {
            this.servicesGroups = servicesGroup;
        });

        this.loadingService.updateShowSpinner(true);
        await this.servicesGroupService.getServicesGroup();
        this.loadingService.updateShowSpinner(false);

        if (this.appointmentWizardSettingsQuery.professionals?.length > 0) {
            this.goToNextStep(IdsStepsAppointmentWizardModel.PROFESSIONALS);
        } else {
            this.goToNextStep(IdsStepsAppointmentWizardModel.DATETIME);
        }
    }

    familyUndoNextStep() {
        this.slideActiveIndex = 0;
        this.resetFamilySearchbar();
    }

    destroyFamilyStep() {}

    /** A partir del Observable de los familias se aplica un filtro de búsqueda del buscador */
    onChangeFamilySearchbar(searchText: string) {
        if (!this.familyFolderSlide[this.slideActiveIndex]) {
            return;
        }

        const familiesFiltered = this.familyFolderSlide[
            this.slideActiveIndex
        ].families.filter((family) => {
            return family.description
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .includes(
                    searchText
                        .toLowerCase()
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                );
        });

        const servicesFiltered = this.familyFolderSlide[
            this.slideActiveIndex
        ].services.filter((service) => {
            return (
                service.description
                    .toLowerCase()
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .includes(
                        searchText
                            .toLowerCase()
                            .normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, '')
                    ) ||
                service.clinicName
                    .toLowerCase()
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .includes(
                        searchText
                            .toLowerCase()
                            .normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, '')
                    )
            );
        });

        this.familyFolderSlideFiltered[
            this.slideActiveIndex
        ].families = familiesFiltered;
        this.familyFolderSlideFiltered[
            this.slideActiveIndex
        ].services = servicesFiltered;
    }

    /** Cuando se marca o desmarca un servicio del listado de servicios, se actualiza en la Store */
    onServiceClicked(serviceAndCheckedEvent: ServiceWizardCheckedEvent) {
        this.familyFolderUserAction$.next(true);
        this.serviceWizardService.setServiceChecked(
            serviceAndCheckedEvent.service.id,
            serviceAndCheckedEvent.checkedEvent
        );
    }

    onServiceToggle(service: ServiceWizard) {
        this.familyFolderUserAction$.next(true);
        this.serviceWizardService.toggleServiceChecked(service.id);
    }

    onPackToggle(pack: PackWizard) {

        pack.serviceIDs.forEach( id => {
            this.serviceWizardService.toggleServiceChecked(id, (!pack.isChecked ||  pack.joinCitation));
        });
        this.packWizardService.toggleChecked(pack);
    }

    familyActionButtonDisabled(): Observable<boolean> {
        return this.servicesChecked$.pipe(
            map((servicesChecked) => {
                if (servicesChecked.length > 0) {
                    return false;
                } else {
                    return true;
                }
            })
        );
    }

    get countFamiliesAndServices() {
        return (
            this.familyFolderSlide[this.slideActiveIndex]?.families.length +
            this.familyFolderSlide[this.slideActiveIndex]?.services.length
        );
    }

    /*------------------------*/
    /** PASO 2: PROFESIONALES */
    /*------------------------*/

    /** Flowwwer template */
    updateSlideActiveProfessionalIndex(step: number) {
        this.slideActiveProfessionalIndex = step;
        this.slideActiveProfessionalIndexSubject.next(step);
    }
    initProfessionalStep() {
        this.updateSlideActiveProfessionalIndex(0);
    }

    /** Paso de selección de profesional. Hemos seleccionado un profesional para un grupo de citas simple */
    onProfessionalClickedSingleGroup(
        professionalServiceGroupSelected: ProfessionalServiceGroupSelected
    ) {
        this.servicesGroupService.setProfessionalWizardChecked(
            professionalServiceGroupSelected
        );
        this.actionNextStep();
    }

    onProfessionalClickedMultipleGroup(
        professionalServiceGroupSelected: ProfessionalServiceGroupSelected
    ) {
        this.servicesGroupService.setProfessionalWizardChecked(
            professionalServiceGroupSelected
        );
    }

    /** Flowwwer template */
    onProfessionalToggle(
        professionalServiceGroupSelected: ProfessionalServiceGroupSelected
    ) {
        this.servicesGroupService.toggleProfessionalWizardChecked(
            professionalServiceGroupSelected
        );
    }

    professionalsNextStep() {
        templateProfessionalsNextStep({
            defaultTemplate: this.slideMainStepProfessional,
            flowwwerTemplate: this.pushSlideProfessional,
        });
    }

    slideMainStepProfessional = () => {
        this.goToNextStep(IdsStepsAppointmentWizardModel.DATETIME);
    };

    pushSlideProfessional = () => {
        if (
            this.servicesGroups.length - 1 >
            this.slideActiveProfessionalIndex
        ) {
            this.updateSlideActiveProfessionalIndex(
                ++this.slideActiveProfessionalIndex
            );
            this.swiperContainer?.nativeElement.swiper.slideTo(
                IdsStepsAppointmentWizardModel.PROFESSIONALS +
                    this.slideActiveProfessionalIndex
            );
        } else {
            this.slideMainStepProfessional();
        }
    };

    popSlideProfessional() {
        this.updateSlideActiveProfessionalIndex(
            --this.slideActiveProfessionalIndex
        );
        this.swiperContainer?.nativeElement.swiper.slideTo(
            IdsStepsAppointmentWizardModel.PROFESSIONALS +
                this.slideActiveProfessionalIndex
        );
    }

    goBackSlideProfessional(): boolean {
        return templateGoBackSlideProfessional({
            defaultTemplate: this.goBackProfessionalDefault,
            flowwwerTemplate: this.goBackProfessionalFlowwwer,
        });
    }

    goBackProfessionalDefault = (): boolean => {
        return true;
    };

    goBackProfessionalFlowwwer = (): boolean => {
        if (this.slideActiveProfessionalIndex > 0) {
            this.popSlideProfessional();
            return false;
        }
        return true;
    };

    /** Solo se hace el reset del profesional si estamos en un único grupo (NO CITA COMPUESTA) */
    professionalUndoNextStep() {
        templateProfessionalUndoNextStep({
            defaultTemplate: this.professionalUndoNextStepDefault,
            flowwwerTemplate: this.professionalUndoNextStepFlowwwer,
        });
    }

    professionalUndoNextStepDefault = () => {
        if (this.servicesGroupQuery.getAll().length === 1) {
            this.servicesGroupService.resetProfessionalWizardCheckedSingleGroup();
        }
    };

    professionalUndoNextStepFlowwwer = () => {
        this.updateSlideActiveProfessionalIndex(0);
    };

    professionalsActionButtonDisabled(): Observable<boolean> {
        return templateProfessionalsActionButtonDisabled({
            defaultTemplate: this.professionalsActionButtonDisabledDefault,
            flowwwerTemplate: this.professionalsActionButtonDisabledFlowwwer,
        });
    }

    professionalsActionButtonDisabledDefault = (): Observable<boolean> => {
        return this.servicesGroup$.pipe(
            map((servicesGroups: ServicesGroup[]) => {
                let valid = true;

                servicesGroups.forEach((servicesGroup: ServicesGroup) => {
                    if (!servicesGroup.professionalSelected) {
                        valid = false;
                    }
                });

                return !valid;
            })
        );
    };

    professionalsActionButtonDisabledFlowwwer = (): Observable<boolean> => {
        return combineLatest([
            this.servicesGroup$,
            this.slideActiveProfessionalIndexSubject,
        ]).pipe(
            map(([servicesGroups, slideActiveProfessionalIndex]) => {
                return (
                    servicesGroups[slideActiveProfessionalIndex]
                        ?.professionalSelected === null
                );
            })
        );
    };

    professionalsStepCheckShowActionButton(): Observable<boolean> {
        return templateProfessionalsStepCheckShowActionButton({
            defaultTemplate: this.professionalsStepCheckShowActionButtonDefault,
            flowwwerTemplate: this
                .professionalsStepCheckShowActionButtonFlowwwer,
        });
    }

    professionalsStepCheckShowActionButtonDefault = (): Observable<boolean> => {
        return this.servicesGroup$.pipe(
            map((servicesGroups: ServicesGroup[]) => {
                if (servicesGroups.length > 1) {
                    return true;
                } else {
                    return false;
                }
            })
        );
    };

    professionalsStepCheckShowActionButtonFlowwwer = (): Observable<
        boolean
    > => {
        return of(true);
    };

    destroyProfessionalsStep() {
        this.servicesGroupService.resetStore();
    }

    /*------------------------*/
    /**   PASO 3: DÍA Y HORA  */
    /*------------------------*/
    async initDatetimeStep() {
        /** Indicamos al componente hijo de calendario que inicialice el mes actual en el que está */
        this.configIsDisabledDate();
        this.times$ = this.appointmentWizardTimeQuery.selectAll();

        this.dateActive$ = this.appointmentWizardDateQuery.selectActive();
        this.timeActive$ = this.appointmentWizardTimeQuery.selectActive();

        this.timeLoading$ = this.appointmentWizardTimeQuery.selectLoading();

        /** TODO: Mirar si podemos acceder a este dato de otra forma, con ngmodel o algo así */
        /** Lanzamos automáticamente los eventos del calendar con la fecha actual (usamos el parámetro date del calendar */
        await this.getDatesDisabled({
            year: this.calendar.date.year,
            month: this.calendar.date.month,
            day: 1,
        });

        this.onDateSelect(this.calendar.date);
    }

    /** Función que calcula las horas seleccionables para reservar la cita */
    async onDateSelect(date: NgbDateStruct) {
        this.isLoadingContent = true;
        if (this.servicesGroupQuery.getAll().length === 1) {
            try {
                await this.appointmentWizardTimeService.getTimesSingleGroup(
                    date,
                    this.servicesGroupQuery.getAll()[0].clinicId
                );
            } catch (error) {
                this.isLoadingContent = false;
            }
        } else {
            try {
                await this.appointmentWizardTimeService.getTimesMultipleGroup(
                    date
                );
            } catch (error) {
                this.isLoadingContent = false;
            }
        }
        this.isLoadingContent = false;
    }

    async onCalendarChange(day: NgbDateStruct) {
        await this.getDatesDisabled(day);
        /** Borramos el listado de horas para no confundir al usuario */
        this.appointmentWizardTimeService.resetStore();

        /** Si la fecha que tenemos marcada es de este mes, llamamos a la api para cargar las horas */
        if (this.calendar.date.month === day.month) {
            this.onDateSelect(this.calendar.date);
        }
    }

    async getDatesDisabled(day: NgbDateStruct) {
        /** Esto solo se hace si tenemos 1 solo grupo de servicios */
        if (this.servicesGroupQuery.getAll().length === 1) {
            this.loadingService.updateShowSpinner(true);
            await this.appointmentWizardDateService.getDatesDisabled(
                day,
                this.servicesGroupQuery.getAll()[0].clinicId
            );
            this.loadingService.updateShowSpinner(false);
        }
    }

    onTimeClicked(time: AppointmentWizardTime) {
        this.appointmentWizardTimeService.setActive(
            time.clinicId + '_' + time.date + '_' + time.timeStart
        );
        this.actionNextStep();
    }

    /** Flowwwer template */
    onTimeSelected(time: AppointmentWizardTime) {
        this.appointmentWizardTimeService.setActive(
            time.clinicId + '_' + time.date + '_' + time.timeStart
        );
    }

    formatDateDisabled(dateString: string): NgbDateStruct {
        const splitDate = dateString.split('-');
        return {
            year: Number(splitDate[0]),
            month: Number(splitDate[1]),
            day: Number(splitDate[2]),
        };
    }

    /** Con esta función vamos a suscribirnos a los cambios de los días deshabilitados que se encuentran en store para que se reflejen en
     * el calendar
     */
    configIsDisabledDate() {
        this.appointmentWizardDateQuery
            .selectAll({
                filterBy: ({ availability }) => !availability,
            })
            .pipe(
                map((dates) => {
                    const datesArray: NgbDateStruct[] = [];
                    dates.map((date) => {
                        if (!date.availability) {
                            datesArray.push(this.formatDateDisabled(date.date));
                        }
                    });
                    return datesArray;
                })
            )
            .subscribe((datesDisabled) => {
                this.isDisabledDateCalendar = (
                    date: NgbDateStruct,
                    current: { month: number; year: number }
                ) => {
                    return !!datesDisabled.find((x) =>
                        NgbDate.from(x).equals(date)
                    );
                };
            });
    }

    dateTimeNextStep() {
        /** Antes de pasar a la confirmación, tenemos que comprobar si el usuario está registrado */
        if (this.userQuery.tokenId !== '') {
            this.goToNextStep(IdsStepsAppointmentWizardModel.CONFIRM);
        } else {
            //this.goToNextStep(IdsStepsAppointmentWizardModel.SOCIAL_LOGIN); E.C.S: Se desactiva esta funcionalidad momentaneamente
            this.goToNextStep(IdsStepsAppointmentWizardModel.REGISTER);
        }
    }

    datetimeUndoNextStep() {}

    destroyDateTimeStep() {
        this.calendar.resetCalendar();
        this.appointmentWizardTimeService.resetStore();
        this.appointmentWizardDateService.resetStore();
    }

    /** Flowwwer template */
    datetimeStepCheckShowActionButton() {
        return templateDatetimeStepCheckShowActionButton({
            defaultTemplate: this.datetimeStepCheckShowActionButtonDefault,
            flowwwerTemplate: this.datetimeStepCheckShowActionButtonFlowwwer,
        });
    }

    datetimeStepCheckShowActionButtonDefault() {
        return of(false);
    }

    datetimeStepCheckShowActionButtonFlowwwer() {
        return of(true);
    }

    datetimeActionButtonDisabled(): Observable<boolean> {
        return templateDatetimeActionButtonDisabled({
            defaultTemplate: this.templateDatetimeActionButtonDisabledDefault,
            flowwwerTemplate: this.templateDatetimeActionButtonDisabledFlowwwer,
        });
    }

    templateDatetimeActionButtonDisabledDefault() {
        of(false);
    }

    templateDatetimeActionButtonDisabledFlowwwer = (): Observable<boolean> => {
        return this.appointmentWizardTimeService.selectActive().pipe(
            map((timeActive) => {
                return !timeActive;
            })
        );
    };

    /*---------------------------*/
    /** PASO 4: SOCIAL LOGIN --- */
    /*---------------------------*/
    initSocialLoginStep() {
        this.socialLoginListener();
    }

    registerDefault() {
        this.actionNextStep();
    }

    socialLoginNextStep() {
        this.goToNextStep(IdsStepsAppointmentWizardModel.REGISTER);
    }

    socialLoginUndoNextStep() {
        this.socialLoginListener();
    }

    socialLoginListener() {
        this.socialLoginService.resetStore();
        this.clientDataSocialLogin = {};
        this.socialLoginResponse$?.unsubscribe();
        this.socialLoginResponse$ = this.socialLoginQuery
            .select()
            .pipe(
                filter((socialLogin) => {
                    return (
                        socialLogin.socialLoginSuccess ||
                        socialLogin.socialLoginFail
                    );
                }),
                take(1)
            )
            .subscribe(async (socialLogin) => {
                if (socialLogin.socialLoginSuccess) {
                    // TODO, si redigijo, controlar que no de error y me quede en la misma página porque ya estoy desuscrito

                    /** Social Login correcto, se ha encontrado al usuario, redirigir */
                    try {
                        await this.userService.checkUserAndLoad();
                        if (this.companyQuery.clientAdvisor) {
                            await this.userService.getReferrerData();
                        }
                    } catch (e) {
                        this.dismissModal();
                        this.routerService.goToMainTabWithoutLogin();
                    }

                    /** Si puedo mostrar el tab de details redirijo a details, si no a perfil */
                    this.goToNextStep(
                        IdsStepsAppointmentWizardModel.CONFIRM,
                        false
                    );
                }

                if (socialLogin.socialLoginFail) {
                    // TODO, si redigijo, controlar que no de error y me quede en la misma página porque ya estoy desuscrito
                    /** Social Login incorrecto, NO se ha encontrado al usuario, ir a Registro con los datos precargados */
                    /** No borrar store, la borra la pantalla de REGISTRO  */
                    this.clientDataSocialLogin = socialLogin.clientData;
                    this.socialLoginService.resetStore();
                    this.goToNextStep(IdsStepsAppointmentWizardModel.REGISTER);
                }
            });
    }

    destroySocialLoginStep() {}

    /*------------------------*/
    /** PASO 4: REGISTER- --- */
    /*------------------------*/
    // TODO: clear del formulario al entrar
    initRegisterStep() {
        this.clinicDetailRgpdDisable$ = this.clinicDetailQuery.select(
            'RGPDDisable'
        );
    }

    async registerNextStep() {
        /** Validamos el registro y pasamos al siguiente paso si está todo_ OK */
        this.loadingService.updateShowSpinner(true);
        await this.submitRegisterForm();
        this.loadingService.updateShowSpinner(false);
    }

    async submitRegisterForm() {
        if (this.registerFormComponent.registerForm.invalid) {
            Object.values(
                this.registerFormComponent.registerForm.controls
            ).forEach((control) => {
                control.markAsTouched();
            });
            return;
        }

        /** Validaciones adicionales de checkboxes */
        if (!this.registerFormComponent.userEnableGeneralConditions) {
            this.toastService.presentErrorToast(
                this.libraryService.getLabel('app_privacy_policy_mandatory')
            );
            return;
        }

        const userRegister: UserRegisterModel = {
            name: this.registerFormComponent.registerForm.value.userName,
            surname1: this.companyQuery.nameSplit
                ? this.registerFormComponent.registerForm.value.userSurname1 ??
                  ''
                : '',
            surname2: this.companyQuery.nameSplit
                ? this.registerFormComponent.registerForm.value.userSurname2 ??
                  ''
                : '',
            phone:
                this.registerFormComponent.registerForm.value.userPhone ?? '',
            email:
                this.registerFormComponent.registerForm.value.userEmail ?? '',
            referrerCode:
                this.registerFormComponent.registerForm.value
                    .userReferrerCode ?? '',
            enableGeneralConditions: this.registerFormComponent
                .userEnableGeneralConditions,
            enableRgpd: this.clinicDetailQuery.RGPDDisable
                ? true
                : this.registerFormComponent.userEnableRgpd,
        };
        /** Registramos el usuario y lo logeamos en el sistema */
        /** OTP: Si no da error, y no se devuelve el clientToken es porque
         * hay que pedir OTP para completar registro */
        const { clientToken, hashCode } = await this.userService.registerUser(
            userRegister
        );
        if (!clientToken) {
            /** Abrimos modal de OTP y esperamos a que se cierre para decidir que hacer */
            const otpModal = await this.modalController.create({
                component: OtpModalComponent,
                componentProps: {
                    hashCode,
                    email: this.registerFormComponent.registerForm.value
                        .userEmail
                },
            });
            await otpModal.present();
            const { data } = await otpModal.onDidDismiss();
            if (data?.action === OTPModalDismissActions.NONE) {
                return;
            }
        }

        try {
            await this.userService.checkUserAndLoad();
            if (this.companyQuery.clientAdvisor) {
                await this.userService.getReferrerData();
            }
        } catch (e) {
            this.dismissModal();
            this.routerService.goToMainTabWithoutLogin();
        }

        // Además borramos el paso del login social para no volver a él tampoco
        this.appointmentWizardSettingsService.removeStepFromStepStack(
            IdsStepsAppointmentWizardModel.SOCIAL_LOGIN
        );
        this.goToNextStep(IdsStepsAppointmentWizardModel.CONFIRM, false);
    }

    registerUndoNextStep() {}

    destroyRegisterStep() {}

    /*------------------------*/
    /** PASO 5: CONFIRMAR --- */
    /*------------------------*/
    initConfirmStep() {
        this.paymentWizardSettingsService.getPaymentWizardSettings();
    }

    confirmNextStep() {

        if (this.userQuery.appDisabled) {
            this.dismissModal();
            this.toastService.presentErrorToast(
                this.libraryService.getLabel('lbl_error_booking')
            );
            return;
        }

        /** Vamos a comprobar si hay que hacer el pago opcionalmente (preguntaremos al usuario), obligatoriamente (iremos al paso de
         * pagar, o no hay que pagar (haremos la reserva de la cita) */
        const appSchedAndBuy = this.paymentWizardSettingsQuery
            .clinicAppSchedAndBuy;

        switch (appSchedAndBuy) {
            case '0':
                /** Hacemos la reserva
                 * TODO: Errores al reservar */
                this.confirmAppointment();
                break;
            case '-1':
                /** Preguntamos al usuario */
                this.optionalPaymentWizard();
                break;
            case '-2':
                /** Siguiente paso: Elegir métodos de pago */
                /** Vamos a la pantalla de pago */
                this.goToNextStep(IdsStepsAppointmentWizardModel.PAYMETHODS);
                break;
            default:
                /** TODO: Mostrar error??¿?¿ */
                break;
        }
    }

    async optionalPaymentWizard() {
        const actionSheet = await this.actionSheetController.create({
            mode: this.platform.is('android') ? 'md' : 'ios',
            header: this.libraryService.getLabel(
                'app_ask_sched_title_action_sheet'
            ),
            cssClass: 'appointment-slide-sheet',
            buttons: [
                {
                    text: this.libraryService.getLabel(
                        'app_ask_sched_continue_action_sheet'
                    ),
                    role: 'continue',
                    handler: () => {},
                },
                {
                    text: this.libraryService.getLabel(
                        'app_ask_sched_cancel_action_sheet'
                    ),
                    role: 'close',
                    handler: () => {},
                },
            ],
        });
        await actionSheet.present();

        const r = await actionSheet.onDidDismiss();
        if (r.role === 'continue') {
            /** Vamos a la pantalla de pago */
            this.goToNextStep(IdsStepsAppointmentWizardModel.PAYMETHODS);
        }
        if (r.role === 'close') {
            /** Confirmamos la cita */
            this.confirmAppointment();
        }
    }

    /** TODO: Manejar el error, podemos estar en la pantalla de confirmar o en la de pago */
    async confirmAppointment() {
        let appointmentId = '';
        this.loadingService.updateShowSpinner(true);
        if (this.servicesGroupQuery.getAll().length === 1) {
            appointmentId = await this.appointmentWizardSettingsService.makeAppointmentSingleGroup(
                this.servicesGroupQuery.getAll()[0].clinicId
            );
        } else {
            appointmentId = await this.appointmentWizardSettingsService.makeAppointmentMultipleGroup();
        }
        this.loadingService.updateShowSpinner(false);

        /** Añadir citas a google calendar */
        this.calendarDeviceService.addAppointmentToCalendarDevice(
            appointmentId
        );

        this.appointmentService.getAppointments();
        this.treatmentService.getTreatments();
        try {
            this.userService.checkUserAndLoad(true);
        } catch (e) {
            this.routerService.goToMainTabWithoutLogin();
        }

        this.goToNextStep(IdsStepsAppointmentWizardModel.RESULT);
    }

    confirmActionButtonDisabled() {
        return combineLatest([
            this.servicesChecked$,
            this.dateActive$,
            this.timeActive$,
        ]).pipe(
            map(([services, date, time]) => {
                if (
                    services.length > 0 &&
                    date?.date !== '' &&
                    time?.timeStart !== ''
                ) {
                    return false;
                } else {
                    return true;
                }
            })
        );
    }

    destroyConfirmStep() {
        this.paymethodWizardService.resetStore();
        this.paymentWizardSettingsService.resetStore();
    }

    getActionLabelConfirmStep() {
        return this.paymentWizardSettingsQuery
            .select('clinicAppSchedAndBuy')
            .pipe(
                map((clinicAppSchedAndBuy) => {
                    if (clinicAppSchedAndBuy === '-2') {
                        return 'app_prepaid_ask';
                    } else {
                        return 'app_ask_sched_step_5_button_confirm';
                    }
                })
            );
    }

    /*--------------------------------------*/
    /** PASO 6: Listado métodos de pago --- */
    /*--------------------------------------*/

    initPaymethodStep() {
        this.paymethodsWizard$ = this.paymethodWizardQuery.selectAll();
    }

    async onPaymethodClicked(paymethod: PaymethodWizard) {
        this.paymethodWizardService.setActive(paymethod.id);

        /** TODO: ver como hacerlo mejor. El set de akita no es asincrono? */
        /** Esperamos a que Akita marque como activo el método de pago para continuar */
        await this.paymethodWizardQuery.selectActive().pipe(
            filter((data) => data !== null && data !== undefined),
            take(1)
        );
        this.actionNextStep();
    }

    /** Flowwwer template */
    async onPaymethodTogle(paymethod: PaymethodWizard) {
        const checked = !this.paymethodWizardQuery.getEntity(paymethod.id)
            .checked;

        this.paymethodWizardService.togglePaymethodChecked(paymethod.id);

        if (checked) {
            this.paymethodWizardService.setActive(paymethod.id);

            /** TODO: ver como hacerlo mejor */
            /** Esperamos a que Akita marque como activo el método de pago para continuar */
            await this.paymethodWizardQuery.selectActive().pipe(
                filter((data) => data !== null && data !== undefined),
                take(1)
            );
        } else {
            this.paymethodWizardService.setActive(null);
        }
    }

    paymethodNextStep() {
        this.paymentWizardSettingsService.createUrlPaymentByAppointment();
        this.goToNextStep(IdsStepsAppointmentWizardModel.PAYMENT);
    }

    paymethodUndoNextStep() {
        templatePaymethodUndoNextStep({
            defaultTemplate: this.templatePaymethodUndoNextStepDefault,
            flowwwerTemplate: this.templatePaymethodUndoNextStepFlowwwer,
        });
    }

    templatePaymethodUndoNextStepDefault = () => {
        this.paymethodWizardService.setActive(null);
    };

    templatePaymethodUndoNextStepFlowwwer = () => {};

    destroyPaymethodStep() {}

    paymethodsStepCheckShowActionButton() {
        return templatePaymethodsStepCheckShowActionButton({
            defaultTemplate: this.paymethodsStepCheckShowActionButtonDefault,
            flowwwerTemplate: this.paymethodsStepCheckShowActionButtonFlowwwer,
        });
    }

    paymethodsStepCheckShowActionButtonDefault() {
        return of(false);
    }

    paymethodsStepCheckShowActionButtonFlowwwer() {
        return of(true);
    }

    paymethodsActionButtonDisabled(): Observable<boolean> {
        return templatePaymethodsActionButtonDisabled({
            defaultTemplate: this.templatepaymethodsActionButtonDisabledDefault,
            flowwwerTemplate: this
                .templatepaymethodsActionButtonDisabledFlowwwer,
        });
    }

    templatepaymethodsActionButtonDisabledDefault() {
        of(false);
    }

    templatepaymethodsActionButtonDisabledFlowwwer = (): Observable<
        boolean
    > => {
        return this.paymethodWizardQuery.selectActive().pipe(
            map((paymethodActive) => {
                return !paymethodActive;
            })
        );
    };
    /*--------------------------------------*/
    /** PASO 7: Pago en proceso------------ */
    /*--------------------------------------*/

    initPaymentStep() {
        const paymethodActive: PaymethodWizard = this.paymethodWizardQuery.getActive();
        this.urlPaymentSafe$ = this.paymentWizardSettingsQuery.selectUrlPaymentSafe();

        /** Creamos un listener para escuchar las respuestas de los iframes de pago */
        window.addEventListener(
            'message',
            (this.listenerEventsPayment = (event) => {
                switch (event.data) {
                    /** Pago OK de cualquier método. Realizar la compra */
                    case paymethodActive.url_ok: {
                        this.ngZone.run(() => {
                            this.confirmAppointment();
                        });

                        window.removeEventListener(
                            'message',
                            this.listenerEventsPayment
                        );
                        break;
                    }

                    case paymethodActive.url_err: {
                        this.ngZone.run(() => {
                            this.goToPrevStep();
                        });
                        this.showAlertErrorPay(
                            this.libraryService.getLabel('app_buy_step_4b_desc')
                        );
                        window.removeEventListener(
                            'message',
                            this.listenerEventsPayment
                        );
                        break;
                    }
                }
            })
        );
    }

    async showAlertErrorPay(message: string) {
        const alert = await this.alertCtrl.create({
            mode: this.platform.is('android') ? 'md' : 'ios',
            message,
            buttons: [
                {
                    text: 'OK',
                    role: 'ok',
                },
            ],
        });
        await alert.present();
    }

    /** No tiene siguiente paso */
    paymentNextStep() {}

    /** No hay que hacer un undo del siguiente paso porque no tiene */
    paymentUndoNextStep() {}

    destroyPaymentStep() {
        this.paymentWizardSettingsService.resetUrlPayment();
        window.removeEventListener('message', this.listenerEventsPayment);
    }

    /*--------------------------------------*/
    /** PASO 8: Resultado del asistente---- */
    /*--------------------------------------*/
    initResultStep() {}

    /** Flowwwer template */
    resultNextStep() {
        this.dismissModal();
    }

    resultUndoNextStep() {}

    destroyResultStep() {}

    /** Flowwwer template */
    resultStepCheckShowActionButton() {
        return templateResultStepCheckShowActionButton({
            defaultTemplate: this.resultStepCheckShowActionButtonDefault,
            flowwwerTemplate: this.resultStepCheckShowActionButtonFlowwwer,
        });
    }

    resultStepCheckShowActionButtonDefault() {
        return of(false);
    }

    resultStepCheckShowActionButtonFlowwwer() {
        return of(true);
    }

    /*---------------------------*/
    /** DESTRUIR MODAL ASISTENTE */
    /*---------------------------*/

    ngOnDestroy(): void {
        this.appointmentWizardSettingsService.resetStore();
        this.serviceWizardService.resetStore();
        this.appointmentWizardDateService.resetStore();
        this.appointmentWizardTimeService.resetStore();
        this.wizardStepService.resetStore();
        this.paymethodWizardService.resetStore();
        this.paymentWizardSettingsService.resetStore();
        this.servicesGroupService.resetStore();
        window.removeEventListener('message', this.listenerEventsPayment);
    }
}
